module.exports = __webpack_public_path__ + "img/853168f.png";